import Subtitle from '../text/Subtitle';
import { useLanguage } from '../../context/LanguageContext';

export default function GameLivesScore({ lives = 0, totalScore = 0 }) {
  const { t } = useLanguage();

  return (
    <div className="flex gap-8">
      <div className="flex gap-1">
        <Subtitle size="small" text={`${t('lives')}${lives}`} />
        <i className="bx bxs-heart text-red text-lg relative bottom-1" />
      </div>
      <Subtitle size="small" text={`${t('score')}${totalScore}`} />
    </div>
  );
}
